@let chat = aiChat();
<app-header [hideHistoryButton]="isTabletSize() && hideHistoryButtonInTabletView()" [title]="chat.conversationName" qaTag="ai-chat">
    <app-icon [attr.data-qa]="'ai-chat-header-icon'" [svgIcon]="chat.aiChatContext === AiChatContextEnum.organisation ? ICONS.CHAT_AI_GLOBUS : ICONS.CHAT_AI"/>
</app-header>

<div [appPanelHostLocation]="PanelLocationEnum.Content" appPanelHost class="chat-container">
    <div #scrollContainer class="chat-messages">
        @for (chatMessage of chat.chatMessages; track i; let i = $index) {
            @let message = chatMessage();
            <div class="single-chat-message">
                @if (message.messageType === AiChatMessageTypeEnum.userPrompt) {
                    <app-icon [iconSize]="AppIconSizeEnum.MEDIUM" [iconUrl]="{url: IconService.getUserIconUrl(userId) | authImage, fallback: ICONS.USER}" class="chatter-icon"/>
                    <div [attr.data-qa]="'user-prompt-' + i" [innerHTML]="message.formattedHtmlMessage" class="chat-message-text"></div>
                } @else if (message.formattedHtmlMessage && message.messageType === AiChatMessageTypeEnum.aiMessage) {
                    <app-icon [attr.data-qa]="'ai-icon'" [iconSize]="AppIconSizeEnum.MEDIUM" [svgIcon]="ICONS.LOGO_AI" class="chatter-icon"/>
                    <div (click)="handleDocumentLinkClick($event)" [attr.data-qa]="'ai-response-' + i"
                         [innerHTML]="message.formattedHtmlMessage"
                         class="chat-message-text"></div>
                } @else {
                    <div [attr.data-qa]="'message-loading-spinner'" class="chat-message-loading-spinner"></div>
                    <div [attr.data-qa]="'message-loading-text'" class="chat-message-text">{{ 'AI_CHAT.GETTING_RESPONSE' | translate }}</div>
                }
            </div>
        }
    </div>

    <div class="user-input-area">

        <div class="textarea-wrapper">
                <textarea #userPrompt
                          (keydown)="onKeyDown($event)"
                          [aria-label]="'AI_CHAT.PROMPT_PLACEHOLDER' | translate"
                          [attr.data-qa]="'user-prompt-input'"
                          [disabled]="chat.isGeneratingMessage"
                          [placeholder]="'AI_CHAT.PROMPT_PLACEHOLDER' | translate"
                          autocomplete="off"
                          class="user-prompt"
                ></textarea>
        </div>

        <div class="submit-button-wrapper">
            <app-button (clicked)="submitChatMessage(userPrompt.value.trim())"
                        [appButtonType]="AppButtonTypeEnum.ICON_ONLY_BUTTON"
                        [buttonColor]="ButtonColorEnum.BLACK_WHITE"
                        [buttonText]="'BUTTON.SUBMIT_PROMPT' | translate"
                        [isDisabled]="chat.isGeneratingMessage || userPrompt.value.trim().length <= 0"
                        [svgIcon]="ICONS.SEND_FLYER"
                        class="submit-question-button"
                        qaTag="submit-question-button"/>
        </div>

        <app-floating-action-button [location]="PanelLocationEnum.Content">
            <app-action-item-group groupTitle="ACTION_GROUP.ACTIONS">
                <app-action-item (clicked)="removeChatOverlay()"
                                 [smallMenuOrderNumber]="0"
                                 [svgIcon]="ICONS.OK"
                                 description="ACTIONS.AI_CHAT.CLOSE"
                                 tag="closeChat"/>
                <app-action-item (clicked)="clearChat()"
                                 [smallMenuOrderNumber]="1"
                                 [svgIcon]="ICONS.TRASH"
                                 description="ACTIONS.AI_CHAT.CLEAR"
                                 tag="clearChat"/>
                @if (!chat.isGeneratingMessage) {
                    <app-action-item (clicked)="shareMessage()"
                                     [smallMenuOrderNumber]="2"
                                     [svgIcon]="ICONS.SENDTO"
                                     description="ACTIONS.AI_CHAT.SHARE"
                                     tag="share"/>
                    @if (chat.aiChatContext === AiChatContextEnum.documents) {
                        @if (chat.chatDocuments.length > 1) {
                            <app-action-item (clicked)="compareDocuments()"
                                             [smallMenuOrderNumber]="3"
                                             [svgIcon]="ICONS.VERGLEICHEN"
                                             description="ACTIONS.AI_CHAT.COMPARE"
                                             tag="compare"/>
                        }
                        <app-action-item (clicked)="summarizeDocuments()"
                                         [smallMenuOrderNumber]="4"
                                         [svgIcon]="ICONS.ZUSAMMENFASSEN"
                                         description="ACTIONS.AI_CHAT.SUMMARIZE"
                                         tag="summarize"/>
                        <app-action-item (clicked)="openPromptSuggestionsPanel()"
                                         [smallMenuOrderNumber]="5"
                                         [svgIcon]="ICONS.VORSCHLAEGE"
                                         description="ACTIONS.AI_CHAT.SUGGESTIONS"
                                         tag="promptSuggestions"/>
                    }
                }
            </app-action-item-group>
        </app-floating-action-button>

        <div [attr.data-qa]="'ai-disclaimer'" class="ai-disclaimer">{{ 'AI_CHAT.AI_DISCLAIMER' | translate }}</div>

    </div>
</div>
